import * as htmlToImage from "html-to-image";

/**
 * Capture a DOM element as a PNG and put it on the clipboard (desktop),
 * share it (mobile), or download it as a fallback.
 *
 * Elements inside the target marked with `data-capture-hide` are hidden
 * during capture (e.g. the copy button itself).
 *
 * Returns "copied" | "shared" | "downloaded".
 */
export async function copyElementAsImage(element, fileName = "doritostats") {
    const hidden = Array.from(element.querySelectorAll("[data-capture-hide]"));
    const previousDisplay = hidden.map((el) => el.style.display);
    hidden.forEach((el) => {
        el.style.display = "none";
    });

    let dataUrl;
    try {
        dataUrl = await htmlToImage.toPng(element, {
            pixelRatio: 2,
            quality: 1,
        });
    } finally {
        hidden.forEach((el, i) => {
            el.style.display = previousDisplay[i];
        });
    }

    const blob = await (await fetch(dataUrl)).blob();
    const file = new File([blob], `${fileName}.png`, { type: "image/png" });

    const isMobile =
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
            navigator.userAgent
        );

    if (isMobile && navigator.share && navigator.canShare?.({ files: [file] })) {
        await navigator.share({ files: [file] });
        return "shared";
    }

    if (
        navigator.clipboard &&
        typeof window !== "undefined" &&
        typeof window.ClipboardItem !== "undefined"
    ) {
        try {
            await navigator.clipboard.write([
                new window.ClipboardItem({ "image/png": blob }),
            ]);
            return "copied";
        } catch (err) {
            console.warn("Clipboard write failed, falling back to download:", err);
        }
    }

    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${fileName}.png`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
    return "downloaded";
}

export default copyElementAsImage;
